import "./Success.scss";

const Success = () => {
  return (
    <div className="success">
      <h2 className="success__title">🎉 Thank you for your order!</h2>
      <p className="success_subtitle">
        You’ll receive an email confirmation shortly.
      </p>
    </div>
  );
};

export default Success;
